export { default as OrderInfo } from './OrderInfo';

